module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dof-cell', {
    attrs: {
      "title": _vm.title,
      "hasArrow": false,
      "hasTopBorder": _vm.hasTopBorder,
      "hasSubBottomBorder": true,
      "cellStyle": {
        backgroundColor: _vm.backgroundColor
      },
      "disabled": _vm.disabled,
      "accessible": true,
      "ariaLabel": (_vm.title + ",状态为" + (_vm.checked ? '已选中' : '未选中') + "," + (_vm.disabled ? '不可更改' : ''))
    },
    on: {
      "dofCellClicked": _vm.dofCellClicked
    }
  }, [(_vm.radioIcon) ? _c('image', {
    staticClass: ["radio"],
    attrs: {
      "slot": "switch",
      "src": _vm.radioIcon
    },
    slot: "switch"
  }) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/template-compiler.js?id=data-v-33feed3d!./~/weex-vue-loader/lib/selector.js?type=template&index=0!./packages/dof-radio/item.vue
// module id = 590
// module chunks = 0 1